import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const TickIcon16 = (props: SvgProps) => <Svg
  width='16'
  height='16'
  viewBox='0 0 16 16'
  fill='none'
  {...props}
>
  <Path
    d='M2 8.21053L5.85714 12L14 4'
    stroke='#0058AD'
    strokeWidth='1.5'
    strokeLinecap='round'
    strokeLinejoin='round'
  />
</Svg>;

export default TickIcon16;
